import { render } from "./App.vue?vue&type=template&id=30d874fc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=30d874fc&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__